import { gql } from "graphql-tag";
import { useQuery } from "@vue/apollo-composable";
import {
  SERVICE_BASIC_INFO,
  ABOUT_INFO,
  INDUSTRIES_INFO,
  OFFERS_INFO,
  TECHNOLOGIES_INFO,
  OUR_EXPERTISES_INFO,
  CLIENT_TECHNOLOGIES_INFO,
  CREDENTIALS_STATS_INFO,
  WHAT_DO_WE_OFFER_INFO,
  SCHEDULE_DEMO_INFO,
  SERVICE_BENEFITS_INFO,
  META_TAG_INFO,
  AGILE_METHOD_INFO,
} from "./component.queries";

export const GET_APP_BY_SLUG = gql`
  query ($slug: String!) {
    apps(filters: { slug: { eq: $slug } }) {
      name
      title
      slug
      description
      main_section_button {
        title
        link
        label
        button_type
        id
        description
      }
      video_sec_model {
        name
        title
        description
        video_btn_cta {
          label
          title
          link
        }
      }
      screenshot_1 {
        url
        alternativeText
      }
      role_wise_features {
        feature_names {
          name
          icon {
            url
            alternativeText
          }
          image {
            url
            alternativeText
          }
        }
        title
        name
      }
      screenshot_2 {
        url
        alternativeText
      }

      our_expertises(pagination: { limit: 100 }) {
        name
        logo {
          url
          alternativeText
        }
      }

      partners {
        name
        logo {
          url
          alternativeText
        }
      }
      categorories {
        slug
        name
      }
      faq {
        title
        description
      }
      why_us {
        title
        description
        image {
          url
          alternativeText
        }
      }
      schedule_demo {
        title
        description
        image {
          url
          alternativeText
        }
      }
      embed_video

      dashboard_screenshots {
        url
        alternativeText
      }
      key_features {
        title
        name
        features {
          title
          description
        }
      }
      app_screens {
        url
        alternativeText
      }
      clone_synonyms
      alias_synonyms
      keywords
      tech_notes
      promo_notes
      app_add_ons {
        title
        description
        features {
          title
          description
        }
      }
      pricing_plan {
        plan_type
        sections {
          label
          title
          price
          price_in_Doller
          cta_btn
          Offer
          cta_link
          one_liner
          features {
            name
            available
            compare
          }
        }
      }
      related_apps {
        name
        title
        slug
        one_liner
        description
        updatedAt
        categorories {
          slug
          name
        }
        tags {
          name
          slug
          categories {
            name
            slug
          }
        }
        our_expertises(pagination: { limit: 10 }) {
          name
        }
        pricing_plan {
          plan_type
          sections {
            price
            price_in_Doller
            Offer
          }
        }
        card_cta_btn {
          id
          title
          label
          link
          button_type
        }
        screenshot_1 {
          url
          alternativeText
          formats
        }
        screenshot_2 {
          url
          alternativeText
          formats
        }
      }
      meander_software_blogs {
        title
        slug
        publishedAt
        updatedAt
        image {
          url
          alternativeText
        }
      }
      meta_tags {
        meta_description
        meta_image {
          url
        }
        meta_keywords
        meta_title
        id
      }
      twitter_tags {
        twitter_title
        twitter_description
        twitter_image {
          url
        }
      }
      og_tags {
        og_title
        og_description
        og_image {
          url
        }
        og_type
      }
    }
  }
`;

export const Search_APP = gql`
  query Apps(
    $filters: AppFiltersInput
    $pagination: PaginationArg
    $sort: [String]
  ) {
    apps(filters: $filters, pagination: $pagination, sort: $sort) {
      name
      description
      slug
    }
  }
`;

export const GET_APPS_LIST = gql`
  query Apps(
    $filters: AppFiltersInput
    $pagination: PaginationArg
    $sort: [String]
  ) {
    apps(filters: $filters, pagination: $pagination, sort: $sort) {
      documentId
      title
      slug

      one_liner
      tags {
        name
        categories {
          name
        }
      }
      isFeatured
      Priorities
      pricing_plan {
        sections {
          price
          price_in_Doller
          Offer
        }
      }
      screenshot_1 {
        url
        formats
      }
      screenshot_2 {
        url
        formats
      }
      categorories {
        name
        slug
      }
      our_expertises(pagination: { limit: 4 }) {
        name
      }
      card_cta_btn {
        id
        label
        link
        title
        button_type
      }
    }
    apps_connection(filters: $filters) {
      pageInfo {
        total
      }
    }
  }
`;

export const GET_APPS = GET_APPS_LIST;
export const GET_NAV_MENU_DATA = gql`
  query GetNavMenuData {
    businessModelCategories(pagination: { limit: 100 }) {
      name
      slug
      business_models {
        plugNPlay
        type
        name
        slug
      }
    }
    products {
      name
      slug
    }
    services {
      name
      slug
    }
    industries {
      name
      slug
    }
    technologiesCategories {
      name
      slug
      technologies {
        name
        slug
      }
    }
  }
`;

export const GET_BLOGS = gql`
  query ($pagination: PaginationArg, $sort: [String]) {
    meanderSoftwareBlogs(pagination: $pagination, sort: $sort) {
      title
      slug
      video_section {
        video_url
        title
        name
      }
      image {
        url
        alternativeText
      }
      publishedAt
      updatedAt
      ms_blog_categories {
        name
        slug
      }
      meta_tags {
        meta_description
        meta_image {
          url
        }
        meta_keywords
        meta_title
        id
      }
      twitter_tags {
        twitter_title
        twitter_description
        twitter_image {
          url
        }
      }
      og_tags {
        og_title
        og_description
        og_image {
          url
        }
        og_type
      }
    }

    meanderSoftwareBlogs_connection {
      pageInfo {
        total
        pageCount
      }
    }
  }
`;

export const GET_BLOG_BY_SLUG = gql`
  query ($slug: String!) {
    meanderSoftwareBlogs(filters: { slug: { eq: $slug } }) {
      title
      content
      related_models {
        name
        description
        title
        slug
        screenshot_2 {
          url
          alternativeText
        }
        screenshot_1 {
          url
          alternativeText
        }
        categorories {
          documentId
          name
          slug
        }
        one_liner
        our_expertises {
          documentId
          name
        }
        card_cta_btn {
          label
          title
          id
          description
          link
          button_type
        }
      }
      one_liner
      video_section {
        video_url
        title
        name
      }
      cta {
        title
        link
        label
      }
      downloadable_file {
        url
        size
        name
        publishedAt
        updatedAt
      }
      updatedAt
      image {
        url
        alternativeText
        createdAt
        documentId
      }
      ms_blog_categories {
        name
        slug
      }
      ms_blog_industries {
        name
        slug
      }
      ms_blog_services {
        name
        slug
      }
      ms_blog_technologies {
        name
        slug
      }
      slug
      faq {
        title
        id
        description
      }
      meta_tags {
        meta_description
        meta_image {
          url
        }
        meta_keywords
        meta_title
        id
      }
      twitter_tags {
        twitter_title
        twitter_description
        twitter_image {
          url
        }
      }
      og_tags {
        og_title
        og_description
        og_image {
          url
        }
        og_type
      }
    }
  }
`;
export const Search_BLOG_BY_SLUG = gql`
  query MeanderSoftwareBlogs($filters: MeanderSoftwareBlogFiltersInput) {
    meanderSoftwareBlogs(filters: $filters) {
      title
      slug
    }
  }
`;
export const GET_BLOG_BY_Category_SLUG = gql`
  query MeanderSoftwareBlogs(
    $filters: MeanderSoftwareBlogFiltersInput
    $pagination: PaginationArg
  ) {
    meanderSoftwareBlogs(filters: $filters, pagination: $pagination) {
      title
      slug
      video_section {
        video_url
        title
        name
      }
      image {
        url
        alternativeText
      }
      publishedAt
      updatedAt
      ms_blog_categories {
        name
        slug
      }
      meta_tags {
        meta_description
        meta_image {
          url
        }
        meta_keywords
        meta_title
        id
      }
      twitter_tags {
        twitter_title
        twitter_description
        twitter_image {
          url
        }
      }
      og_tags {
        og_title
        og_description
        og_image {
          url
        }
        og_type
      }
    }
    meanderSoftwareBlogs_connection {
      pageInfo {
        total
        pageCount
      }
    }
  }
`;
export const GET_BLOG_BY_service_SLUG = gql`
  query MeanderSoftwareBlogs(
    $filters: MeanderSoftwareBlogFiltersInput
    $pagination: PaginationArg
    $meanderSoftwareBlogsConnectionFilters2: MeanderSoftwareBlogFiltersInput
  ) {
    meanderSoftwareBlogs(filters: $filters, pagination: $pagination) {
      title
      slug
      image {
        url
        alternativeText
      }
      publishedAt
      updatedAt
    }
    meanderSoftwareBlogs_connection(
      filters: $meanderSoftwareBlogsConnectionFilters2
    ) {
      pageInfo {
        total
        pageCount
      }
    }
  }
`;
export const GET_SERVICES_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } }) {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;

export const GET_INDUSTRY_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } }) {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;

export const GET_INTEGRATION = gql`
  query Apps($filters: AppFiltersInput) {
    apps(filters: $filters) {
      name
      slug
    }
  }
`;

export const GET_TECHNOLOGY_BY_SLUG = gql`
  query ($slug: String!) {
    services(filters: { slug: { eq: $slug } }) {
      ...ServiceBasicInfo
      ...AboutInfo
      ...IndustriesInfo
      ...OffersInfo
      ...TechnologiesInfo
      ...OurExpertisesInfo
      ...ClientTechnologiesInfo
      ...CredentialsStatsInfo
      ...WhatDoWeOfferInfo
      ...ScheduleDemoInfo
      ...ServiceBenefitsInfo
      ...MetaTagInfo
      ...AgileMethodInfo
    }
  }
  ${SERVICE_BASIC_INFO}
  ${ABOUT_INFO}
  ${INDUSTRIES_INFO}
  ${OFFERS_INFO}
  ${TECHNOLOGIES_INFO}
  ${OUR_EXPERTISES_INFO}
  ${CLIENT_TECHNOLOGIES_INFO}
  ${CREDENTIALS_STATS_INFO}
  ${WHAT_DO_WE_OFFER_INFO}
  ${SCHEDULE_DEMO_INFO}
  ${SERVICE_BENEFITS_INFO}
  ${META_TAG_INFO}
  ${AGILE_METHOD_INFO}
`;

export function useGetAppBySlug(slug) {
  return useQuery(GET_APP_BY_SLUG, { slug });
}
export function useSearch_APP(query) {
  const variables = {
    filters: {
      or: [
        {
          clone_synonyms: {
            containsi: query,
          },
        },
        {
          alias_synonyms: {
            containsi: query,
          },
        },
        {
          keywords: {
            containsi: query,
          },
        },
        {
          name: {
            containsi: query,
          },
        },
        {
          description: {
            containsi: query,
          },
        },
      ],
    },
    pagination: { page: 1, pageSize: 100 },
  };

  return useQuery(Search_APP, { variables });
}

export function useGetServicesBySlug(slug) {
  return useQuery(GET_SERVICES_BY_SLUG, { slug });
}

export function useGetNavMenuData() {
  return useQuery(GET_NAV_MENU_DATA);
}
export function useGetBlogs(PaginationArg) {
  return useQuery(GET_BLOGS, PaginationArg);
}

export function useGetIntegration(type) {
  const variables = {
    filters: {
      type: {
        eq: type,
      },
    },
  };
  return useQuery(GET_INTEGRATION, variables);
}
export function useGetBlogBySlug(slug) {
  return useQuery(GET_BLOG_BY_SLUG, { slug });
}
export function Use_Search_BLOG_BY_SLUG(slug) {
  const variables = {
    filters: {
      title: {
        containsi: slug,
      },
    },
  };
  return useQuery(Search_BLOG_BY_SLUG, { variables });
}
export function useGetBlogByCategorySlug(slug, PaginationArg) {
  const variables = {
    filters: {
      ms_blog_categories: {
        slug: {
          eq: slug,
        },
      },
    },
    pagination: PaginationArg,
  };
  return useQuery(GET_BLOG_BY_Category_SLUG, { variables });
}

export const GET_CATEGORIES = gql`
  query {
    tags(pagination: { limit: 100 }) {
      documentId
      name
      slug
    }
  }
`;

export const GET_WEBINARS = gql`
  query Webinars($pagination: PaginationArg, $filters: WebinarFiltersInput) {
    webinars(pagination: $pagination, filters: $filters) {
      documentId
      title
      one_liner
      description
      webinar_date
      webinar_url
      webinar {
        id
        webinar_type
        price
        discount
        btn_url
      }
      createdAt
      updatedAt
      publishedAt
      why_it_matter {
        id
        title
        cards {
          id
          card_title
          card_one_line
        }
        price_inr
        price_doller
        price_card_one_line
      }
    }
  }
`;

export function useGetWebinars(variables = {}) {
  return useQuery(GET_WEBINARS, variables);
}

export const GET_PACKAGE_BY_SLUG = gql`
  query GetPackageBySlug($slug: String!) {
    package_connection(filters: { slug: { eq: $slug } }) {
      nodes {
        package_name
        slug
        tagline
        pricing_config {
          original_price
          discount_pct
          currency
          tax_rate
        }
        urgency {
          timer_seconds
          fomo_demand
          spots_left
        }
        features {
          text
        }
        hero_image {
          url
          alternativeText
        }
      }
    }
  }
`;

export function useGetPackageBySlug(slug) {
  return useQuery(GET_PACKAGE_BY_SLUG, { slug });
}
